import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { PlumbingPermit } from 'types/Documents';

export const usePlumbingPermit = (id: string | null) =>
  useDocumentDetails<Document<PlumbingPermit> | null>(id);
